import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {BASE_URL} from "../../app.environment";
import {ImageDetail} from "../types/groups/types";
import {ApproveImage, ApproveJobsImage, ApproveSearchedImage, DeleteGroupImage} from "../types/groups/params";
import {catchError, Observable, switchMap, throwError} from "rxjs";
import {MessageService} from "primeng/api";

@Injectable({
    providedIn: 'root'
})
export class ImageService {
    httpClient = inject(HttpClient)
    messageService = inject(MessageService);
    baseApiUrl = BASE_URL;

    constructor() {
    }

    getImageContent(url: string): Observable<Blob> {
        return this.httpClient.get(url, { responseType: 'blob', }).pipe(
            catchError(error => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load image' });
                throw error;
            })
        );
    }

    approve(image: ImageDetail, value: boolean) {
        const body: ApproveImage = {
            image_id: image.id!,
            value: value
        }

        this.httpClient.post(`${this.baseApiUrl}/approve`, body).pipe(
            catchError((error) => this.handleError(error))
        ).subscribe((response) => {
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Successfully updated approved field'
            });
        })
    }

    approveJobs(image: ImageDetail, value: boolean, makeId: number) {
        const body: ApproveJobsImage = {
            sjc_id: image.sjc_id,
            image_id: image.image_id!,
            sjc_group_sjc_inspection_image_id: image.sjc_group_sjc_inspection_image_id!,
            make_id: makeId,
            sjc_group_id: image.sjc_group_id,
            value: value
        }

        this.httpClient.post(`${this.baseApiUrl}/approve_jobs`, body).pipe(
            catchError((error) => this.handleError(error))
        ).subscribe((response) => {
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Successfully updated approved field'
            });
        })
    }


    approveGroups(image: ImageDetail, value: boolean, makeId: number) {
        const body: ApproveJobsImage = {
            sjc_id: image.sjc_id,
            make_id: makeId,
            image_id: image.sjc_inspection_image_id!,
            sjc_group_sjc_inspection_image_id: image.sjc_group_sjc_inspection_image_id!,
            sjc_group_id: image.sjc_group_id,
            value: value
        }

        return this.httpClient.post(`${this.baseApiUrl}/approve_groups`, body).pipe(
            catchError((error) => this.handleError(error))
        )
    }


    approveSearchImage(body: ApproveSearchedImage) {
        this.httpClient.post(`${this.baseApiUrl}/approve_searched_image`, body).pipe(
            catchError((error) => this.handleError(error))
        ).subscribe((response) => {
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Successfully updated approved field'
            });
        })
    }

    deleteGroupImage(image: ImageDetail, makeId: number) {
        const body: DeleteGroupImage = {
            sjc_id: image.sjc_id,
            make_id: makeId,
            image_id: image.sjc_inspection_image_id!,
            sjc_group_sjc_inspection_image_id: image.sjc_group_sjc_inspection_image_id!,
            sjc_group_id: image.sjc_group_id
        }

        return this.httpClient.post(`${this.baseApiUrl}/groups/image/delete`, body)
    }

    handleError(error: HttpErrorResponse) {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to update'});
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }

}
